// import classes from '*.module.css'
import {
  Grid,
  InputLabel,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDatePicker from "../../../Components/CustomDatePicker";
import CustomTimePicker from "../../../Components/CustomTimePicker";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import Header from "./header";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import DateComponent from "../../../Components/FormGenerator/datepicker_component";
import CircularIndeterminate from "../../../Components/Loader";
import { KeyboardTimePicker, TimePicker } from "@material-ui/pickers";
import moment from "moment";

function DueDiligence(props: any) {
  var pdata: any = [
    {
      available_date: "",
      from: "",
      to: "",
      internal_notes: "", //Optional
      partner_notes: "", //Optional
      actions: "", //Optional
    },
  ];
  const data = {
    // assignee_id: '',
    available_date: "",
    from: "",
    to: "",
    converted_from: "",
    converted_to: "",
    internal_notes: "",
    partner_notes: "asdadas",
    actions: "",
  };

  const classes = useStyles();
  const dispatch = useDispatch();
  const global_data = useSelector((state: any) => state.stepperReducer);
  const [userData, setUserData] = useState(data);
  const [scheduleData, setScheduleData]: any = useState(pdata);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [loading, setLoading] = useState(false);
  let role = sessionStorage.getItem("role");

  const onScheduleChangeItem = (
    inputStateValue: any,
    inputId: any,
    index: any
  ) => {
    console.log(`object`, inputStateValue, inputId);
    // console.log(`object`, moment(inputStateValue).format("HH:MM"))
    console.log(`object`, moment(inputStateValue, "HH:mm:ss").format("LT"));
    setScheduleData(
      scheduleData.map((option: any, i: any) => {
        if (i == index) {
          option[inputId] = inputStateValue;
          option["converted_" + inputId] = moment(
            inputStateValue,
            "HH:mm:ss"
          ).format("LT");
          option[inputId] != ""
            ? setSubmitClickFlag(false)
            : setSubmitClickFlag(true);
        }
        return option;
      })
    );
  };
  const onScheduleInputState = (
    inputStateValue: any,
    inputId: any,
    index: any
  ) => {
    setScheduleData(
      scheduleData.map((option: any, i: any) => {
        if (i == index) {
          option[inputId] = inputStateValue;
          option[inputId] != ""
            ? setSubmitClickFlag(false)
            : setSubmitClickFlag(true);
        }
        return option;
      })
    );
  };
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
    if (global_data.due_diligence_id != null) {
      setLoading(true);
      AdminPartnerClient.DueDiligenceCall_get({
        id: global_data.due_diligence_id,
      })
        .then((response: any) => {
          var localArr: any = [];
          response.data.attributes.due_diligence_available_slots.length > 0
            ? response.data.attributes.due_diligence_available_slots.map(
                (option: any) => {
                  localArr.push({
                    available_date: option.available_date,
                    from: option.from,
                    to: option.to,
                    internal_notes: option.internal_notes,
                    partner_notes: option.partner_notes,
                    actions: option.actions,
                  });
                }
              )
            : localArr.push({
                available_date: "",
                from: "",
                to: "",
                internal_notes: "",
                partner_notes: "",
                actions: "",
              });

          scheduleData.length = 0;
          setScheduleData(scheduleData.concat(localArr));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {}, [scheduleData]);

  const onSubmit = () => {
    var flag = true;
    console.log(scheduleData);
    if (flag) {
      setSubmitClickFlag(false);
      setLoading(true);
      if (global_data.due_diligence_id == null) {
        AdminPartnerClient.DueDiligenceCall({
          due_diligence_available_slots_attributes: scheduleData,
          partner_profile_id: global_data.partner_profile,
        })
          .then((response: any) => {
            dispatch({
              type: GLOBAL_STEPPER_DATA,
              payload: { due_diligence_id: response.data.id },
            });
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information saved successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        AdminPartnerClient.DueDiligenceCall_put(global_data.due_diligence_id, {
          due_diligence_available_slots_attributes: scheduleData,
          partner_profile_id: global_data.partner_profile,
        })
          .then(() => {
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information updated successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    } else {
      setSubmitClickFlag(true);
    }
  };

  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };
  const deleteCalls = (index: any) => {
    console.log(index);
    var localArr: any = scheduleData.filter(
      (option: any, i: any) => i != index
    );
    console.log("object", localArr, index);
    scheduleData.length = 0;
    setScheduleData(scheduleData.concat(localArr));
  };

  return (
    <div style={{ marginBottom: 40 }} ref={firstElementRef}>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        justify="space-between"
      >
        <Grid item xs={10}></Grid>
        <Grid item xs={2}>
          <Button
            onClick={() => {
              setScheduleData(scheduleData.concat(pdata));
            }}
            type="submit"
            color="secondary"
            variant="contained"
            style={{
              cursor: "pointer",
              textTransform: "initial",
              marginLeft: "-20px",
              marginTop: "20px",
            }}
          >
            Add due diligence call
          </Button>
        </Grid>
      </Grid>
      {scheduleData.length > 0 &&
        scheduleData.map((option: any, index: any) => {
          return (
            <Grid
              container
              direction="row"
              alignItems="flex-start"
              style={{ padding: 30, marginBottom: 20 }}
            >
              <Grid item xs={10}>
                <Grid container direction="row" alignItems="flex-start">
                  <Grid item xs={4}>
                    <Typography variant="h2">Due diligence</Typography>
                  </Grid>
                  <Grid item xs={3} style={{ padding: 0, paddingRight: 0 }}>
                    <Grid container direction="row" alignItems="flex-start">
                      <Grid item xs={12}>
                        <Typography variant="h2">Date</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{ paddingLeft: 10, paddingRight: 0 }}
                  >
                    <Grid container direction="row" alignItems="flex-start">
                      <Grid item xs={12}>
                        <Typography variant="h2">Time</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={4}></Grid>
                  <Grid item xs={3} style={{ padding: 0, paddingRight: 0 }}>
                    <Grid container direction="row" alignItems="flex-start">
                      <Grid item xs={12}>
                        <DateComponent
                          key={index}
                          componentObject={{
                            componentType: "datePicker",
                            required: true,
                            label: "",
                            name: "available_date",
                            placeholder: "DD/MM/YYYY",
                            indexKey: "0-" + index,
                            index: "available_date",
                            futureDateHide: false,
                            helperText: false,
                            handleChange: onScheduleInputState,
                            value: option.available_date,
                            selectValue: { index },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{ padding: 10, paddingRight: 0, marginBottom: 20 }}
                  >
                    <Grid
                      container
                      direction="row"
                      alignItems="flex-start"
                      spacing={1}
                    >
                      <Grid item xs={6}>
                        <KeyboardTimePicker
                          value={option.from}
                          id="from"
                          className={classes.custom_timepicker}
                          placeholder="08:00 AM"
                          mask="__:__ _M"
                          helperText=""
                          onChange={(e) =>
                            onScheduleChangeItem(e, "from", index)
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <KeyboardTimePicker
                          value={option.to}
                          id="to"
                          placeholder="08:00 AM"
                          mask="__:__ _M"
                          className={classes.custom_timepicker}
                          showTodayButton
                          todayLabel="now"
                          minutesStep={5}
                          helperText=""
                          onChange={(e) => onScheduleChangeItem(e, "to", index)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={1} style={{ padding: 10 }}>
                                    <Grid container direction="row" alignItems="flex-start" justify="space-between">
                                        {
                                            index == 0 ?
                                                <Grid item xs={12}>
                                                    <AddCircleIcon type="submit"
                                                        onClick={() => {
                                                            setScheduleData(scheduleData.concat(pdata))
                                                        }}
                                                        fontSize="large" color="secondary"
                                                        style={{ cursor: 'pointer', marginTop: "-16px" }} />

                                                </Grid>
                                                : <Grid item xs={6}>
                                                    <AddCircleIcon type="submit"
                                                        onClick={() => { deleteCalls(index) }}
                                                        fontSize="large" color="error"
                                                        style={{ cursor: 'pointer', marginTop: "-16px", transform: 'rotate(45deg)' }} />
                                                </Grid>
                                        }
                                    </Grid>
                                </Grid> */}
                </Grid>

                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Due diligence notes</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomInput
                      id="internal_notes"
                      variant="outlined"
                      placeholder="Due diligence notes"
                      multiline={true}
                      rows={4}
                      parentcall={onScheduleInputState}
                      dataIndex={index}
                      defaultValue={option.internal_notes}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Due diligence actions</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomInput
                      id="actions"
                      variant="outlined"
                      placeholder="Due diligence actions"
                      multiline={true}
                      rows={4}
                      parentcall={onScheduleInputState}
                      dataIndex={index}
                      defaultValue={option.actions}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} style={{ padding: 1 }}>
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  justify="space-between"
                >
                  {/* {index == 0 && ( */}
                  {/* <Grid item xs={12}>
                      <Button
                        onClick={() => {
                          setScheduleData(scheduleData.concat(pdata));
                        }}
                        type="submit"
                        color="secondary" variant="contained"
                        style={{ cursor: "pointer", marginTop: "-16px",textTransform:"initial" }}
                      >
                        Add due diligence call
                      </Button>
                    </Grid> */}
                  {/* )  } */}
                  <Grid item xs={6}>
                    <AddCircleIcon
                      type="submit"
                      onClick={() => {
                        deleteCalls(index);
                      }}
                      fontSize="large"
                      color="error"
                      style={{
                        cursor: "pointer",
                        marginTop: "10px",
                        transform: "rotate(45deg)",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      <Header
        isBack={true}
        saveBtnTitle={"Save and proceed"}
        parentcall={onSubmit}
        parentBackCall={onBack}
      />
      {loading && <CircularIndeterminate />}
    </div>
  );
}

export default DueDiligence;

const useStyles = makeStyles(() => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
  custom_timepicker: {
    "& .MuiInputBase-root": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: 5,
    },
    "& .MuiInputBase-input": {
      padding: "9px 12px !important",
      fontSize: 16,
    },
    "& .MuiInput-underline.Mui-error:after, & .MuiInput-underline:before": {
      content: "' '",
      border: "0px !important",
      transition: "none",
    },
    "& .MuiIconButton-root": {
      padding: "0px 5px 0px 0px",
    },
  },
}));
